export const i18nKeyPrefix = 'MAIN-FAMILY'
